import toNumber from 'lodash/toNumber';
import lodashIsEmpty from 'lodash/isEmpty';

export const formatToNumber = (value: string | number): number =>
  toNumber(value);

export const isEmpty = (value: unknown): boolean => lodashIsEmpty(value);
